import React from 'react';
import { Building2, Bot, Workflow, ShieldCheck, Boxes, Sparkles } from 'lucide-react';

const Impact = () => {
  const impacts = [
    {
      icon: <Building2 className="text-brand-primary" size={28} />,
      title: "Enterprise-System Transformation",
      description: "Led and supported enterprise-system transformation, replacing legacy ways of working with modern digital platforms; contributed to technical requirements, UAT, stakeholder alignment, implementation readiness and adoption."
    },
    {
      icon: <Sparkles className="text-brand-primary" size={28} />,
      title: "AI Agents with Copilot Studio",
      description: "Created and configured AI agents using Microsoft Copilot Studio, including training and refining them to automate tasks, answer business questions and support processes securely."
    },
    {
      icon: <Bot className="text-brand-primary" size={28} />,
      title: "AI-Assisted Internal Platforms",
      description: "Designed and developed internal digital platforms, including training and HR tools, using AI-assisted development. These solutions are actively used within the organisation to improve access to information, consistency and operational efficiency."
    },
    {
      icon: <Workflow className="text-brand-primary" size={28} />,
      title: "Workflow & Document Automation",
      description: "Built and improved workflow automation and document-generation processes using Microsoft 365 and Power Automate, reducing manual hand-offs and improving traceability and auditability."
    },
    {
      icon: <ShieldCheck className="text-brand-primary" size={28} />,
      title: "Governance, Privacy & Security",
      description: "Embedded governance, privacy and information-security thinking into process and system change through practical application of GDPR, OneTrust and ISO 27001-aligned controls."
    },
    {
      icon: <Boxes className="text-brand-primary" size={28} />,
      title: "Product Development & Launch",
      description: "Contributed to product development, product launches, pre-sales and preparation for mass production across more than 15 devices/products."
    }
  ];

  return (
    <section id="impact" className="py-24 bg-bg-page" data-testid="impact-section">
      <div className="container mx-auto px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="heading-2 text-brand-primary mb-6">Selected Impact</h2>
            <p className="body-large max-w-3xl mx-auto">
              Outcome-focused examples of transformation, governance and automation delivery across regulated and technology-led organisations
            </p>
          </div>

          {/* Impact Grid */}
          <div className="grid md:grid-cols-2 gap-8">
            {impacts.map((item, index) => (
              <div key={index} className="team-card p-8 flex flex-col" data-testid={`impact-card-${index}`}>
                <div className="flex items-start space-x-4 mb-4">
                  {item.icon}
                  <h3 className="heading-5 text-text-primary">{item.title}</h3>
                </div>
                <p className="body-small text-text-primary flex-1">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impact;
